//! @/script/contacts.js

var popup = {
  show: function () {
    $("html").addClass("popup-open");

    setTimeout(function () {
      $("html").addClass("popup-show");
      $(window).trigger("resize");
    }, 100);
  },
  hide: function () {
    $("html").removeClass("popup-show");

    setTimeout(function () {
      $("html").removeClass("popup-open");
    }, 500);
  },
};

var feedback = {
  send: function () {
    var $form = $("#form-feedback");

    if (!formValidate($form)) return;

    buttonLoad($("#button-feedback"));

    $.post(
      "index.php?route=rmx/contacts/feedback",
      $("#form-feedback").serialize()
    )
      .fail(function () {
        responseError();
      })
      .done(function (response) {
        buttonReset($("button.loading"));

        if (!responseCheck(response)) return;

        ymGoalFeedback();

        setTimeout(function () {
          popup.hide();

          $("#form-feedback .form-control").val("");
        }, 500);
      });
  },
};
